export default {
  name: 'smsPurchase',
  data() {
    return {
      userName: '',
      cIndex: 0, //  选中的短信包
      amt: 0, //  售价
      hospitalId: '',
      surplusAmount: 0, //  剩余短信条数
      messageList: [],
      smsId: '', // 购买短信包的ID
      orderSn: '', // 短信包购买后支付预订单号
      isAwaitPaying: false, //  是否在等待扫码支付状态
      visible: false,
      awaitTime: 60, //  等待时间
      payCode: '', // 微信支付码
      tableData: [], // 短信购买记录列表
    };
  },
  methods: {
    //  查询此诊所短信信息
    getHospitalSmsConfig() {
      this.$api.member.getSurplusSmsNum().then((res) => {
        this.surplusAmount = res.surplusAmount || 0;
        this.userName = res.hospitalName;
        this.hospitalId = res.hospitalId;
      });
    },
    //  查询系统短信包配置
    getSmsPurchaseConfig() {
      this.$api.member.getSmsPurchaseConfig().then((res) => {
        if (res) {
          this.messageList = res.smsPageInfos;
          this.smsId = this.messageList[0].id; // 默认设置第一个短信模板的ID
          this.amt = this.messageList[0].pageAmount; // 默认选择第一个短信包
        }
      });
    },
    //  切换短信包
    activeHandler(index, price, id) {
      this.smsId = id; // 设置短信包ID
      this.cIndex = index;
      this.amt = price;
      console.log('短信', id);
    },
    //  短信包支付预付获得订单
    getSmsPurchaseOrdeSn() {
      this.$api.member.getSmsPurchaseOrdeSn(this.smsId).then((res) => {
        if (res) {
          this.orderSn = res.orderSn;
        }
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error,
        });
      })
    },
    //  微信扫码支付待支付页面
    openPay() {
      this.$confirm('即将进行微信扫码支付，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.visible = true;
        this.isAwaitPaying = true;
        this.getSmsPurchaseOrdeSn();
        this.runTime();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消微信扫码支付'
        })
      })
    },
    //  支付倒计时
    runTime() {
      setTimeout(() => {
        this.awaitTime--;
        if (this.awaitTime !== 0 && this.isAwaitPaying) {
          this.runTime();
        } else {
          this.close();
          this.awaitTime = 60;
        }
      }, 1000);
    },
    //  扫码支付
    scanPay() {
      if (this.orderSn) {
        this.$api.member.scanPaySmsOrder({
          smsId: this.smsId,
          payCode: this.payCode,
        }).then((res) => {
          this.getOrderStatus();
          this.close();
        }).catch((error) => {
          this.close();
          this.$message({
            type: 'error',
            message: error,
          });
        });
      }
    },
    //  直接跳转第三方支付
    directPay() {
      this.$confirm('即将进行直接短信支付，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const mywin = window.open();
        this.orderSn = undefined; // 以防万一，清除已设置的订单号
        console.log('直接支付时', this.smsId);
        this.$api.member.getSmsPurchaseOrdeSn(this.smsId).then((res) => {
          if (res) {
            this.orderSn = res;
            console.log(this.orderSn);
            if (this.orderSn) {
              this.$api.member.directPaySmsOrder(this.orderSn).then((res) => {
                if (res) {
                  console.log('请求地址', res);
                  // 新打开支付窗口
                  mywin.location.href = res.payInfo;
                  // window.open(res.payInfo);
                }
              }).catch((error) => {
                this.$message({
                  type: 'error',
                  message: '对不起，生成订单有误，请重新点击购买',
                });
              });
            }
          }
        }).catch((error) => {
          this.$message({
            type: 'info',
            message: '对不起，生成订单有误，请重新点击购买',
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消直接购买短信包！',
        });
      })

    },
    //  关闭窗口
    close() {
      this.visible = false;
    },
    //  查询订单状态
    getOrderStatus() {
      console.log('短信购买单', this.orderSn);
      this.$api.member.checkOrderStatus(this.smsId).then(() => {
        this.$message({
          type: 'success',
          message: '支付成功，请在一分钟后查询短信数量！',
        });
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '很遗憾，短信购买失败！',
        });
      })
    },
    //  查询购买短信包成功记录
    getAllSmsPayRecord() {
      this.$api.member.getAllSmsPayRecord().then((res) => {
        this.tableData = res || [];
      });
    },
  },
  mounted() {
    this.getHospitalSmsConfig();
    this.getSmsPurchaseConfig();
    this.getAllSmsPayRecord();
  },
  watch: {
    //  监听code 状态有没有输入
    payCode(val) {
      if (val.length === 18) {
        this.scanPay();
      }
    },
  },
};
